import { Context } from "./context.js";
import UUIDMetric from "./metrics/types/uuid.js";
import EventMetricType from "./metrics/types/event.js";
import { EVENTS_PING_NAME } from "./constants.js";
import log, { LoggingLevel } from "./log.js";
const LOG_TAG = "core.glean_metrics";
var GleanMetrics;
(function (GleanMetrics) {
    const metrics = {
        pageLoad: new EventMetricType({
            category: "glean",
            name: "page_load",
            sendInPings: [EVENTS_PING_NAME],
            lifetime: "ping",
            disabled: false,
        }, ["url", "referrer", "title"]),
        elementClick: new EventMetricType({
            category: "glean",
            name: "element_click",
            sendInPings: [EVENTS_PING_NAME],
            lifetime: "ping",
            disabled: false,
        }, ["id", "type", "label", "url", "referrer", "title"]),
        pageId: new UUIDMetric({
            category: "glean",
            name: "page_id",
            sendInPings: [EVENTS_PING_NAME],
            lifetime: "application",
            disabled: false,
        })
    };
    function pageLoad(overrides) {
        var _a, _b, _c;
        if (!Context.initialized) {
            log(LOG_TAG, "Attempted to record a page load event before Glean was initialized. This is a no-op.", LoggingLevel.Warn);
            return;
        }
        metrics.pageId.generateAndSet();
        metrics.pageLoad.record({
            url: (_a = overrides === null || overrides === void 0 ? void 0 : overrides.url) !== null && _a !== void 0 ? _a : (typeof window !== "undefined"
                ? window.location.href
                : "URL_NOT_PROVIDED_OR_AVAILABLE"),
            referrer: (_b = overrides === null || overrides === void 0 ? void 0 : overrides.referrer) !== null && _b !== void 0 ? _b : (typeof document !== "undefined"
                ? document.referrer
                : "REFERRER_NOT_PROVIDED_OR_AVAILABLE"),
            title: (_c = overrides === null || overrides === void 0 ? void 0 : overrides.title) !== null && _c !== void 0 ? _c : (typeof document !== "undefined"
                ? document.title
                : "TITLE_NOT_PROVIDED_OR_AVAILABLE"),
        });
    }
    GleanMetrics.pageLoad = pageLoad;
    function constructClickEventContextForElement(element) {
        const dataset = element.dataset;
        const elementClickEventContext = {
            ...(dataset.gleanId && { id: dataset.gleanId }),
            ...(dataset.gleanType && { type: dataset.gleanType }),
            ...(dataset.gleanLabel && { label: dataset.gleanLabel }),
            url: (typeof window !== "undefined"
                ? window.location.href
                : "URL_NOT_PROVIDED_OR_AVAILABLE"),
            referrer: (typeof document !== "undefined"
                ? document.referrer
                : "REFERRER_NOT_PROVIDED_OR_AVAILABLE"),
            title: (typeof document !== "undefined"
                ? document.title
                : "TITLE_NOT_PROVIDED_OR_AVAILABLE"),
        };
        return elementClickEventContext;
    }
    function handleClickEvent(event) {
        const clickedElement = event.target;
        const closestElementWithClickAttributes = clickedElement.closest("[data-glean-id], [data-glean-type], [data-glean-label]");
        if (!closestElementWithClickAttributes) {
            return;
        }
        const elementClickEventContext = constructClickEventContextForElement(closestElementWithClickAttributes);
        recordElementClick(elementClickEventContext);
    }
    GleanMetrics.handleClickEvent = handleClickEvent;
    function recordElementClick(elementClickEventContext) {
        if (!Context.initialized) {
            log(LOG_TAG, "Attempted to record element click event before Glean was initialized. This is a no-op.", LoggingLevel.Warn);
            return;
        }
        metrics.elementClick.record(elementClickEventContext);
    }
    GleanMetrics.recordElementClick = recordElementClick;
})(GleanMetrics || (GleanMetrics = {}));
export default GleanMetrics;
